import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DinerAssignmentSkeletonComponent } from './diner-assignment-skeleton.component';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [DinerAssignmentSkeletonComponent],
  imports: [CommonModule, IonicModule],
  exports: [DinerAssignmentSkeletonComponent]
})
export class DinerAssignmentSkeletonComponentModule {}
